import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostListCustomerPage(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/listCustomer`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCountCustomerPage(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/countCustomer`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostListCustomerQueryPage(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/listCustomerQueryPage`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCountCustomerQueryPage(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/countCustomerQueryPage`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetCustomerDetail(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/h5/getCustomerDetail/${params.id}`, 
    METHOD.GET
  )
}

export async function rqtGetCustomerRiskDetail(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/getCustomerRiskDetail`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCustomeVisitInfo(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/listCustomerVisitQueryPage`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetCustomeInvestRecordInfo(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/getCustomeInvestRecord/${params.id}`,
    METHOD.GET
  )
}

export async function rqtGetCustomerBasic(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/getCustomeBasicForm/${params.id}`,
    METHOD.GET
  )
}

export async function rqtGetCustomerSave(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/saveCustomerInfo`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetCustomerVisitSave(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/saveCustomerVisitInfo`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetCustomerBasicFormsSave(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/saveCustomerBasicFormInfo`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetCreateCustBasciForm(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/createCustomerBasicForm`,
    METHOD.GET,
    params
  )
}

export async function rqtGetCreateComCustBasciForm(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/createComCustomerBasicForm`,
    METHOD.GET,
    params
  )
}

export async function rqtGetCustomerAccount(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/getCustomerAccount/${params.customerId}`,
    METHOD.GET
  )
}
export async function rqtGetCustomerAdress(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/getCustomerAddress/${params.customerId}`,
    METHOD.GET
  )
}


export async function rqtGetCustomerAccountById(id) {
  return request(
    `${BASE_URL}/provider/cms/customer/customer/account/${id}`,
    METHOD.GET
  )
}
export async function rqtGetCustomerAdressById(id) {
  return request(
    `${BASE_URL}/provider/cms/customer/customer/address/${id}`,
    METHOD.GET
  )
}

export async function rqtGetAllAgent(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCustomerAssetList(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/asset/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostEquityInvestmentList(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/query/equityinvestment/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostSaveallwms(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/saveallwms`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetEquityInvestmentDetailCustomer(id, params) {
  return request(
    `${BASE_URL}/provider/cms/customer/query/equityinvestment/${id}/detail/customer`,
    METHOD.GET,
    params
  )
}

export async function rqtGetEquityInvestmentDetailProduct(id, params) {
  return request(
    `${BASE_URL}/provider/cms/customer/query/equityinvestment/${id}/detail/product`,
    METHOD.GET,
    params
  )
}

export async function rqtGetEquityInvestmentDetailAssetRecord(id, pid, params) {
  return request(
   (params == null ? `${BASE_URL}/provider/cms/customer/query/equityinvestment/${id.id}/${id.pid}/detail/assetrecord` 
        : `${BASE_URL}/provider/cms/customer/query/equityinvestment/${id}/${pid}/detail/assetrecord`),
    METHOD.GET,
    params
  )
}

export async function rqtGetCustomer(id, agentId, params) {
  return request(
    `${BASE_URL}/provider/cms/customer/allwms/${id}/${agentId}`,
    METHOD.GET,
    params
  )
}

export async function rqtPostTradeFixList(params) {
  return request(
    `${BASE_URL}/provider/wx/wms/trade/fix/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostTradeEquityList(params) {
  return request(
    `${BASE_URL}/provider/wx/wms/trade/equity/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCustomeAddrsInfo(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/saveCustomerAddrsInfo`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

//修改增加邮箱
export async function rqtPostUpdateEmail(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/weChatUpdateContact`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
export async function rqtGetCustomerForIdentify(params) {
  return request(
    `${BASE_URL}/provider/cms/customer/identify`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
